export default {
  dialogModal: {
    message: {
      en: `
        We are very sorry but this offer is available for the new subscribers only. Please contact
        our customer support at <Link mailto="support@scentbird.com">support@scentbird.com</Link>
        if you believe it's a mistake
      `,
    },
    button: {
      en: 'Finish',
    },
  },
}
